import React, { useEffect, useState } from "react";
import {
  MdAdd,
  MdClose,
  MdDelete,
  MdEdit,
  MdMail,
  MdPeopleOutline,
  MdPhone,
  MdSend,
  MdTimer,
  MdVisibility,
  MdLocationOn,
  MdBusiness,
  MdGroup,
  MdAssignment,
} from "react-icons/md";
import { useNavigate } from "react-router-dom";
import CountUp from "react-countup";
import api from "../../../services/api";
import {
  Card,
  ViewInput,
  Table,
  Scroll,
  InputTel,
  Message,
} from "../../../GlobalStyles";
import { toast } from "react-toastify";
import {
  Button,
  Modal,
  Input,
  Pagination,
  DatePicker,
  Select,
  Tooltip,
  Spin,
} from "antd";
import { FaWhatsapp } from "react-icons/fa";
import { addDays, format } from "date-fns";
import {
  Container,
  ContainerLead,
  Label,
  AssociateInfo,
  InfoTag,
} from "./styles";
import dayjs from "dayjs";
import weekday from "dayjs/plugin/weekday";
import localeData from "dayjs/plugin/localeData";
import userPhoto from "../../../images/user.png";
import { getValue } from "../../../services/functions";

const { TextArea } = Input;
const { RangePicker } = DatePicker;

dayjs.extend(weekday);
dayjs.extend(localeData);

const LeadsEnviados = () => {
  const navigate = useNavigate();

  const [leads, setLeads] = useState([]);
  const [lead, setLead] = useState({});
  const [leadsTotal, setLeadsTotal] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [isLoadingModal, setIsLoadingModal] = useState(false);
  const [id, setId] = useState("");
  const [dateStart, setDateStart] = useState(addDays(new Date(), -30));
  const [dateEnd, setDateEnd] = useState(new Date());
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenLead, setIsOpenLead] = useState(false);
  const [user, setUser] = useState("");
  const [users, setUsers] = useState([]);
  const [name, setName] = useState("");
  const [status, setStatus] = useState("");
  const [email, setEmail] = useState("");
  const [phone_number, setPhone_number] = useState("");
  const [observation, setObservation] = useState("");
  const [employees, setEmployees] = useState("");
  const [necessity, setNecessity] = useState("");
  const [cnpj, setCnpj] = useState("");
  const [all, setAll] = useState(true);
  const [location, setLocation] = useState("");

  const getStatusClass = (status) => {
    const s = status || "";
    if (s.includes("Cliente Fechado")) return "fechado";
    if (s.includes("Cliente Perdido")) return "perdido";
    if (s.includes("Oportunidade")) return "oportunidade";
    return "";
  };

  useEffect(() => {
    loadLeads(page, all, dateStart, dateEnd, user, status);
  }, [page, all, dateStart, dateEnd, user, status]);

  useEffect(() => {
    loadFranqueados();
  }, []);

  async function loadFranqueados() {
    await api
      .get(`/users/franqueado?all=true`)
      .then((response) => {
        setUsers(response.data.users);
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente",
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
  }

  async function loadLeads(page, all, dateStart, dateEnd, user, status) {
    await api
      .get(
        `/leads?page=${page}${
          !all ? `&dateStart=${dateStart}&dateEnd=${dateEnd}` : ""
        }${user ? `&userId=${user}` : ""} ${status ? `&status=${status}` : ""}`,
      )
      .then((response) => {
        let leads = response.data.leads;
        leads.map((item) => {
          item.contracts.map((data) => {
            item.valueContract = 0;
            data.services.map((service) => {
              item.valueContract += service.amount * service.value;
            });
            if (data.service_value) {
              item.valueContract += data.service_value;
            }
            if (data.discount) {
              item.valueContract -= data.discount;
            }
          });
          item.completedValue = item.contracts.reduce((total, contract) => {
            return contract.status === "assinado"
              ? total + item.valueContract
              : total;
          }, 0);
          item.lostValue = item.contracts.reduce((total, contract) => {
            return contract.status === "expirado" ||
              contract.status === "recusado"
              ? total + item.valueContract
              : total;
          }, 0);
        });
        setLeads(leads);
        setLeadsTotal(response.data.leadsTotal);
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente",
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
    setIsLoading(false);
  }

  function getDate(date) {
    let fortmatDate = date.split("/");
    return new Date(fortmatDate[2], fortmatDate[1] - 1, fortmatDate[0]);
  }

  return (
    <Container>
      <h1>Leads Enviados</h1>

      {isLoading ? (
        <Spin size="large" style={{ marginTop: 50 }} />
      ) : (
        <>
          <Card>
            <p>Total</p>
            <CountUp duration={1} end={leadsTotal} separator="." />
          </Card>
          <div className="filters-row">
            <ViewInput style={{ width: "100%", maxWidth: 220 }}>
              <p>Filtrar por Franqueado</p>
              <Select
                placeholder="selecionar franqueado"
                value={user}
                showSearch
                optionFilterProp="children"
                style={{ width: "100%", textAlign: "left" }}
                onChange={(value) => {
                  setUser(value);
                  setPage(0);
                }}
              >
                <Select.Option value={""}>Todos Franqueados</Select.Option>
                {users.map((item) => {
                  return (
                    <Select.Option key={item.id} value={item.id}>
                      {item.name}
                    </Select.Option>
                  );
                })}
              </Select>
            </ViewInput>
            <ViewInput style={{ width: "100%", maxWidth: 180 }}>
              <p>Filtrar por Status</p>
              <Select
                placeholder="selecionar status"
                value={status}
                showSearch
                optionFilterProp="children"
                style={{ width: "100%", textAlign: "left" }}
                onChange={(value) => {
                  setStatus(value);
                  setPage(0);
                }}
              >
                <Select.Option value={""}>Todos Status</Select.Option>
                {[
                  "Oportunidade",
                  "Abordagem",
                  "Atendimento",
                  "Qualificação",
                  "Proposta Enviada",
                  "Negociação",
                  "Cliente Fechado",
                  "Cliente Perdido",
                ].map((s) => (
                  <Select.Option key={s} value={s}>
                    {s}
                  </Select.Option>
                ))}
              </Select>
            </ViewInput>
            <ViewInput style={{ width: "100%", maxWidth: 200 }}>
              <p>Visualizar</p>
              <div style={{ display: "flex", gap: 10 }}>
                <Button
                  style={{
                    backgroundColor: all ? "#008037" : "#FFF",
                    color: all ? "#FFF" : "#008037",
                    flex: 1,
                    borderColor: "#008037",
                    borderRadius: 50,
                  }}
                  onClick={() => {
                    setAll(true);
                  }}
                >
                  Todos
                </Button>
                <Button
                  style={{
                    backgroundColor: !all ? "#008037" : "#FFF",
                    color: !all ? "#FFF" : "#008037",
                    flex: 1,
                    borderColor: "#008037",
                    borderRadius: 50,
                  }}
                  onClick={() => {
                    setAll(false);
                  }}
                >
                  Período
                </Button>
              </div>
            </ViewInput>
            {!all && (
              <ViewInput style={{ width: "100%", maxWidth: 280 }}>
                <p>Alterar Periodo de Cadastro</p>
                <RangePicker
                  style={{ width: "100%" }}
                  placeholder={["inicial", "final"]}
                  value={[
                    dateStart ? dayjs(dateStart) : "",
                    dateEnd ? dayjs(dateEnd) : "",
                  ]}
                  format={"DD/MM/YYYY"}
                  onChange={(value, dateString) => {
                    if (value) {
                      setDateStart(value[0].toDate());
                      setDateEnd(value[1].toDate());
                    }
                    setPage(0);
                  }}
                  allowClear={false}
                />
              </ViewInput>
            )}
          </div>
          {leads?.length ? (
            <div className="leads-list">
              {leads.map((lead) => (
                <div className="lead-card" key={lead.id}>
                  <div className="main-info">
                    <Tooltip title={lead.name}>
                      <strong>{lead.name}</strong>
                    </Tooltip>
                    <div
                      className={`status-badge ${getStatusClass(lead.status)}`}
                    >
                      {lead.status}
                    </div>
                  </div>

                  <div className="info-item">
                    <label>Franqueado</label>
                    <Tooltip title={lead.user?.name}>
                      <span
                        style={{
                          maxWidth: 150,
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {lead.user?.name}
                      </span>
                    </Tooltip>
                  </div>

                  <div className="info-item">
                    <label>Fechado / Perdido</label>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <span style={{ color: "#52c41a", fontWeight: "bold" }}>
                        {(lead.completedValue || 0).toLocaleString("pt-br", {
                          style: "currency",
                          currency: "BRL",
                        })}
                      </span>
                      <span style={{ color: "#f5222d" }}>
                        {(lead.lostValue || 0).toLocaleString("pt-br", {
                          style: "currency",
                          currency: "BRL",
                        })}
                      </span>
                    </div>
                  </div>

                  <div className="info-item">
                    <label>Propostas</label>
                    <span>{lead.contracts.length} enviada(s)</span>
                  </div>

                  <div className="info-item">
                    <label>Última Atualização</label>
                    <span>
                      {format(new Date(lead.update_at), "dd/MM/yyyy HH:mm")}
                    </span>
                  </div>

                  <div className="actions">
                    <Tooltip title="Visualizar Lead">
                      <Button
                        shape="circle"
                        icon={<MdVisibility size={18} />}
                        onClick={() => {
                          setLead(lead);
                          setIsOpenLead(true);
                        }}
                      />
                    </Tooltip>
                  </div>
                </div>
              ))}

              <Pagination
                style={{
                  margin: "25px 0",
                  alignSelf: "center",
                }}
                defaultCurrent={page + 1}
                onChange={(page) => {
                  setPage(page - 1);
                }}
                total={leadsTotal}
                pageSize={30}
                showTotal={(total) => `${total} leads`}
              />
            </div>
          ) : (
            <div
              style={{
                background: "#fff",
                padding: 50,
                borderRadius: 15,
                textAlign: "center",
                border: "1px solid #eee",
              }}
            >
              <MdPeopleOutline
                size={50}
                color="#ccc"
                style={{ marginBottom: 15 }}
              />
              <Message>Nenhum lead encontrado.</Message>
            </div>
          )}
        </>
      )}

      <Modal
        title={id ? "Editando lead" : "Cadastrando um novo lead"}
        width={500}
        confirmLoading={isLoadingModal}
        open={isOpen}
        okText={id ? "Editar" : "Cadastrar"}
        cancelText="Cancelar"
        onOk={() => {
          //createLead()
        }}
        onCancel={() => {
          setIsOpen(false);
        }}
      >
        <ViewInput>
          <p>Nome*</p>
          <Input
            placeholder="nome"
            value={name}
            onChange={(event) => setName(event.target.value)}
          />
        </ViewInput>
        <ViewInput>
          <p>Email*</p>
          <Input
            placeholder="email"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
          />
        </ViewInput>
        <ViewInput>
          <p>Telefone*</p>
          <InputTel
            mask="(99) 99999-9999"
            maskChar=""
            noSpaceBetweenChars={true}
            value={phone_number}
            placeholder={"telefone"}
            onChange={(text) => {
              setPhone_number(text.target.value.replace(/[^0-9]/g, ""));
            }}
          />
        </ViewInput>
        <ViewInput>
          <p>Necessidade</p>
          <Input
            placeholder="necessidade"
            value={necessity}
            onChange={(event) => setNecessity(event.target.value)}
          />
        </ViewInput>
        <ViewInput>
          <p>Funcionários</p>
          <Input
            placeholder="funcionários"
            value={employees}
            onChange={(event) => setEmployees(event.target.value)}
          />
        </ViewInput>
        <ViewInput>
          <p>CNPJ</p>
          <Input
            placeholder="cnpj"
            value={cnpj}
            onChange={(event) => setCnpj(event.target.value)}
          />
        </ViewInput>
        <ViewInput>
          <p>Localização</p>
          <Input
            placeholder="localização"
            value={location}
            onChange={(event) => setLocation(event.target.value)}
          />
        </ViewInput>
        <ViewInput>
          <p>Observação</p>
          <TextArea
            style={{ minHeight: 60 }}
            placeholder="observação"
            value={observation}
            onChange={(event) => setObservation(event.target.value)}
          />
        </ViewInput>
      </Modal>

      {/* Modal Detalhado do Lead */}
      <Modal
        width={500}
        open={isOpenLead}
        onCancel={() => setIsOpenLead(false)}
        footer={null}
        closable={false}
        styles={{ content: { padding: 0 } }}
      >
        <div
          style={{
            position: "relative",
            background: "#fff",
            borderRadius: 5,
            padding: "25px 20px 20px 20px",
            borderTop: "30px solid #d7f0db",
          }}
        >
          <MdClose
            style={{
              position: "absolute",
              cursor: "pointer",
              top: -25,
              right: 10,
            }}
            size={20}
            color="#333"
            onClick={() => setIsOpenLead(false)}
          />
          <header
            style={{
              position: "absolute",
              top: -22,
              left: 15,
              display: "flex",
              alignItems: "center",
            }}
          >
            <Label color={"#008037"} />
            <p
              style={{
                marginLeft: 5,
                fontSize: 12,
                fontWeight: 500,
                color: "#000a",
              }}
            >
              Detalhes do Lead
            </p>
          </header>

          <h2 style={{ marginTop: 10, fontSize: 22 }}>{lead.name}</h2>

          <InfoTag>
            {lead.email && (
              <div className="tag">
                <MdMail size={14} /> {lead.email}
              </div>
            )}
            {lead.phone_number && (
              <div className="tag">
                <MdPhone size={14} /> {lead.phone_number}
              </div>
            )}
            {lead.location && (
              <div className="tag">
                <MdLocationOn size={14} /> {lead.location}
              </div>
            )}
            {lead.cnpj && (
              <div className="tag">
                <MdBusiness size={14} /> CNPJ: {lead.cnpj}
              </div>
            )}
            {lead.employees && (
              <div className="tag">
                <MdGroup size={14} /> {lead.employees} func.
              </div>
            )}
            {lead.necessity && (
              <div className="tag">
                <MdAssignment size={14} /> {lead.necessity}
              </div>
            )}
          </InfoTag>

          <div style={{ margin: "15px 0" }}>
            <p style={{ fontSize: 13, color: "#666", marginBottom: 5 }}>
              Observações do Cadastro:
            </p>
            <p style={{ fontSize: 14, fontWeight: "normal", color: "#333" }}>
              {lead.observation || "Sem observações adicionais."}
            </p>
          </div>

          <div
            style={{
              background: "#f9f9f9",
              padding: 15,
              borderRadius: 10,
              margin: "15px 0",
            }}
          >
            <p style={{ fontSize: 12, color: "#888", margin: 0 }}>
              Valor Estimado:
            </p>
            <p
              style={{
                fontSize: 20,
                color: "#008037",
                fontWeight: "bold",
                margin: 0,
              }}
            >
              {getValue(lead.value || 0)}
            </p>
          </div>

          <div style={{ display: "flex", gap: 15, marginTop: 10 }}>
            {lead.phone_number && (
              <FaWhatsapp
                size={22}
                color="#25D366"
                style={{ cursor: "pointer" }}
                onClick={() =>
                  window.open(
                    `https://api.whatsapp.com/send/?phone=55${lead.phone_number}`,
                  )
                }
              />
            )}
            {lead.phone_number && (
              <MdPhone
                size={22}
                color="#333"
                style={{ cursor: "pointer" }}
                onClick={() => window.open(`tel:${lead.phone_number}`)}
              />
            )}
            {lead.email && (
              <MdMail
                size={22}
                color="#EA4335"
                style={{ cursor: "pointer" }}
                onClick={() => window.open(`mailto:${lead.email}`)}
              />
            )}
          </div>

          {!!lead.leads?.length && (
            <div style={{ marginTop: 20 }}>
              <p style={{ margin: "10px 0", fontSize: 13, fontWeight: "bold" }}>
                Histórico de Envio ({lead.leads?.length}):
              </p>
              <div style={{ maxHeight: 150, overflowY: "auto", padding: 5 }}>
                {lead.leads?.map((item, index) => (
                  <div
                    key={index}
                    style={{
                      borderBottom:
                        index + 1 !== lead.leads?.length
                          ? "1px solid #eee"
                          : "none",
                      padding: "8px 0",
                    }}
                  >
                    <p
                      style={{
                        fontSize: 13,
                        color: "#333",
                        margin: 0,
                        fontWeight: 600,
                      }}
                    >
                      {item.user?.name}
                    </p>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginTop: 4,
                      }}
                    >
                      <span
                        style={{
                          fontSize: 12,
                          color: "#008037",
                          fontWeight: 700,
                        }}
                      >
                        {item.status}
                      </span>
                      <span style={{ fontSize: 11, color: "#999" }}>
                        {format(new Date(item.create_at), "dd/MM/yyyy HH:mm")}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {lead.user && (
            <AssociateInfo>
              <img
                src={lead.user.photo ? lead.user.photo_url : userPhoto}
                alt="Perfil"
              />
              <div className="info">
                <span>Franqueado atual:</span>
                <strong>{lead.user?.name}</strong>
              </div>
            </AssociateInfo>
          )}
        </div>
      </Modal>
    </Container>
  );
};

export default LeadsEnviados;
